import { render, staticRenderFns } from "./CertificatCommentsNormatif.vue?vue&type=template&id=14516e62&"
import script from "./CertificatCommentsNormatif.vue?vue&type=script&lang=js&"
export * from "./CertificatCommentsNormatif.vue?vue&type=script&lang=js&"
import style0 from "./CertificatCommentsNormatif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports